<div *ngIf="preview.attribution" [ngClass]="{ 'sidebar-embedded': sidebarEmbedded, popover: !sidebarEmbedded }">
  <div class="flex flex-col p-4 w-64 gap-4 breakdown">
    <div class="flex justify-between items-end breakdown__header">
      <span class="text-night-darker strong">{{ customCurrentPriceLabel || 'Your current price' }}</span>
      <span class="text-night-darker strong" *ngIf="currentPrice">
        {{ currentPrice && Math.round(currentPrice.amount) | currency: currentPrice.currency : 'symbol' : '1.0-0' }}
      </span>
    </div>

    <!-- Price breakdown -->
    <div class="flex flex-col gap-2 breakdown__body">
      <p class="nomargin font-semibold">Price calculation</p>
      <div class="flex flex-col gap-1 pl-3">
        <!-- Base Rate Row -->
        <div class="flex justify-between items-center py-1 breakdown__body__base-rate">
          <span>Base price</span>
          <span class="font-mono">
            {{ preview.base_display.slice(0, -3) }}
          </span>
        </div>
        <!-- attribution details -->
        <ng-container *ngFor="let adjustment of preview.attribution | keyvalue">
          <div
            class="flex justify-between items-center py-1 breakdown__body__attribution-row"
            *ngIf="adjustment.value.amount !== 0">
            <span>
              {{ DynamicPricingPreviewAttributionMap[adjustment.key] ?? adjustment.key | humanize }}
            </span>
            <span class="font-mono">
              {{ adjustment.value?.display.startsWith('-') ? '' : '+' }}{{ adjustment.value.display.slice(0, -3) }}
            </span>
          </div>
        </ng-container>
      </div>
      <mat-divider></mat-divider>
      <!-- Final Hospitable Dynamic Rate -->
      <div class="flex justify-between items-center text-raspberry-darker breakdown__body__dynamic-price">
        <span class="font-semibold text-primary">Dynamic price</span>

        <span class="font-semibold text-primary font-mono">
          {{ preview.display.slice(0, -3) }}
        </span>
      </div>
    </div>
  </div>
</div>
